import { validateEmail } from "../../../../../common/helper";

export default function ({ cta, title }) {
    const ctaWithoutSpace = cta.replace(/\s+/g, "");

    // zasto ovdje  TS ne javlja ak stavis cta da nije string
    const link = validateEmail(ctaWithoutSpace)
        ? `mailto:${ctaWithoutSpace}?subject=Prijava za poziciju ${title} putem dzobs.com oglasa.`
        : ctaWithoutSpace;

    const openCTA = () => {
        window.open(link, "_blank");
    };

    return (
        <div className="text-center p-4 sticky md:static md:my-16 bottom-0 flex align-center justify-center width-100 shadow md:shadow-none bg-white">
            <button className="btn-primary" onClick={openCTA}>
                Apliciraj za ovaj posao
            </button>
        </div>
    );
}
